import { AutoComplete, Button, Card, Checkbox, Col, DatePicker, Divider, Empty, Input, InputRef, Row, Select, Space, Spin, Table, Tag, Tooltip, message, notification } from 'antd'
import React, { useEffect, useRef } from 'react'
import FloatLabel from '../../components/FloatLabel/floatLabel';
import { ColumnType , ColumnsType } from 'antd/es/table';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBuAndClientDetails_OBO } from '../../store/reducers/orderDashboardSlice';
import { formatNumberWithCommas, rejectedApiMessage } from '../../utilities/CommonHelper';
import { fetchOBOReport, getOboDownloadFile, setoboModalDetails } from '../../store/reducers/reportsSlice';
import moment from 'moment';
import dayjs from 'dayjs';
import { SearchOutlined } from '@ant-design/icons';
import DashboardCard from '../../components/DashboardCard/dashboardCard';
import { EyeOutlined,MailOutlined } from '@ant-design/icons';
import OboDetailsModal from '../OboDetailsModal/oboDetailsModal';
import { FilterConfirmProps } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import { DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import Link from 'antd/es/typography/Link';


interface DataType  {
  client: string
  opportunityID: string;
  opportunityName: string;
  sumOfTCV: string;
  revenue: string;
  obo: string;
  
}

type DataIndex = keyof DataType;


const OboReportContainer = () => {
  
  const dispatch = useDispatch();
  const selectRef_type = useRef<any>(null);
  const selectRef_tillmonth = useRef<any>(null);
  const selectRef_month = useRef<any>(null);
  const selectRef_quarter = useRef<any>(null);
  const reportsData = useSelector((state: any) => state.reports);
  const orderDashboardData = useSelector((state: any) => state.orderDashboard);
  
  const [buList, setBuList] = React.useState<any>([]);
  const [clientList, setClientList] = React.useState<any>([]);
  const [selectedClient, setSelectedClient] = React.useState<any>([]);
  const [selectedBu, setSelectedBu] = React.useState<any>([]);
  const [oboReportData, setOboReportData] = React.useState<any>([]);
  const [totalopportunity, setTotalOpportunity] = React.useState<any>('');
  const [totalContractValue, setTotalContractValue] = React.useState<any>('');
  const [totalRevenueRecognised, setTotalRevenueRecognised] = React.useState<any>('');
  const [totalOBO, setTotalOBO] = React.useState<any>('');
  const [revenueMonth, setRevenueMonth] = React.useState<any>("");
  const [oboModalVisible, setoboModalVisible] = React.useState(false);
  const [showTable, setShowTable] = React.useState(false);
  const [showDownloadReport, setShowDownloadReport] = React.useState(false);
  const [selectedOboType, setSelectedOboType] = React.useState<any>(null);
  const [noDataFlag, setNoDataFlag] = React.useState(false);
  const [selectQuarters, setSelectQuarters] = React.useState<any>([]);
  const [quarterOptions, setQuarterOptions] = React.useState<any>([]);
  const [startDate, setStartDate] = React.useState<any>(null);
  const [endDate, setEndDate] = React.useState<any>(null);
  const [isMailFlag, setIsMailFlag] = React.useState(false);
  
  const [searchText, setSearchText] = React.useState('');
  const [searchedColumn, setSearchedColumn] = React.useState('');
  const searchInput = React.useRef<InputRef>(null);
  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  
  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
      ref={searchInput}
      placeholder={`Search ${dataIndex}`}
      value={selectedKeys[0]}
      onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
      onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
      style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
      <Button
      type="primary"
      onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
      icon={<SearchOutlined />}
      size="small"
      style={{ width: 90 }}
      >
      Search
      </Button>
      <Button
      onClick={() => {
        setSelectedKeys([]);
        handleSearch([], confirm, dataIndex);
      }}
      size="small"
      style={{ width: 90 }}
      >
      Reset
      </Button>
      </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex]
    .toString()
    .toLowerCase()
    .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
      <Highlighter
      highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
      searchWords={[searchText]}
      autoEscape
      textToHighlight={text ? text.toString() : ''}
      />
    ) : (
      text
    ),
  });

  const oboTypeOptions = [
    {
      value: 'TillMonth',
      label: 'Till Month',
    },
    {
      value: 'Quarter',
      label: 'Quarter Wise',
    },
    {
      value: 'Month',
      label: 'Month Wise',
    },
    {
      value: 'CustomRange',
      label: 'Custom Range',
    }
  ];
  
  
  
  useEffect(() => {
    if(clientList.length===0 || buList.length===0){
      dispatch(fetchBuAndClientDetails_OBO()).then((res: any) => {
        if (res.type === 'orderDashboard/fetchBuAndClientDetails_OBO/fulfilled') {
          setBuList(res.payload?.buList?res.payload?.buList:[]);
          setClientList(res.payload?.clientList?res.payload?.clientList:[]);
          
        }else{
          rejectedApiMessage(res.payload);
        } 
      });
    }
    
    
    
  }, [])
  
  useEffect(() => {
    setoboModalVisible(reportsData?.oboModal?.isModalOpen);
  },[reportsData?.oboModal?.isModalOpen]);
  
  
  useEffect(() => {
    getQuarters();
  },[])
  
  //function to get the list of last 8 quaters in label value pair to display in quaters dropdown
  const getQuarters = () => {
    let tempQuarterOptions:any = [];
    let currentQuarter = quarterOfYear(new Date());
    let currentYear = new Date().getFullYear();
    let currentQuarterObject = {value:currentYear+'-'+currentQuarter,label:currentYear+' Quarter '+currentQuarter};
    tempQuarterOptions?.push(currentQuarterObject);
    let tempQuarter = currentQuarter;
    for(let i=1;i<8;i++){
      tempQuarter = tempQuarter-1;
      if(tempQuarter<1){
        tempQuarter = 4+tempQuarter;
        currentYear = currentYear-1;
      }
      let tempcurrentQuarterObject = {value:currentYear+'-'+tempQuarter,label:currentYear+' Quarter '+tempQuarter};
      
      tempQuarterOptions.push(tempcurrentQuarterObject);
    }
    setQuarterOptions(tempQuarterOptions);
  }
  
  
  
  
  
  
  const viewSOWLevelOBO = (record:any) => {
    setoboModalVisible(true);
    dispatch(setoboModalDetails({
      isModalOpen:true,
      selectedSOW:{},
      selectedOpp:record,
      activeTab:'sowTab'
    }));
  }

  const getKeyValueForBU=(selectedBuValueList:any[])=>{
    let tempSelectedBuList :any[] = [];
    selectedBuValueList.map((item:any) => {
      let temp = buList.filter((bu:any) => bu.value===item);
      if(temp.length>0){
        tempSelectedBuList.push(...temp);
      }
      
    });
    return tempSelectedBuList;
  }
  const handleChangedValue = (field:string,value:any) => {
    
    if(field==='client'){
      setSelectedClient(value);
    }else if(field==='bu'){    
      setSelectedBu(getKeyValueForBU(value));
    }
    else if(field==='revenueMonth'){
      setRevenueMonth(value);
    }
    else if(field==='oboType'){
      selectRef_type.current?.blur();
      setSelectedOboType(value);
      setRevenueMonth(null);
      setStartDate(null);
      setEndDate(null);
      setSelectQuarters([]);
      
    }
    else if(field==='selected_quarters'){ 
      //sort the selected quarters in ascending order
      if(selectQuarters.length>0 && selectQuarters.length>value.length){
        let _value = [...value];
        let _missingQuarter = selectQuarters.filter((quarter:any) => !_value.includes(quarter));
        let _indexOfMissingQuarter = selectQuarters.findIndex((quarter:any) => quarter===_missingQuarter[0]);
        if(_indexOfMissingQuarter!=0 && _indexOfMissingQuarter!=selectQuarters.length-1){
          return;
        }
      }
      value.sort((a:any,b:any) => {
        let _a:any =  moment(getQuarterStartDate(a));
        let _b:any = moment(getQuarterStartDate(b));
        return _b-_a;
      });
      setSelectQuarters(value);
    }
    else if(field==='custom_startDate'){
      setStartDate(value.toISOString());
    }
    else if(field==='custom_endDate'){
      setEndDate(value.toISOString());
    }
    setShowDownloadReport(false);
    
  }
  const getSelectedBu = (selectedBu:any[]) => {
    let tempSelectedBuList = [];
    tempSelectedBuList = selectedBu.map((item:any) => {
      return item.value;
    });
    return tempSelectedBuList;
  }
  
  //function to get the quarter start date based on the quarter value as 2024-1
  const getQuarterStartDate = (quarter:any) => {
    let quarterValue = quarter.split('-');
    if(quarterValue.length>1){
      if(quarterValue[1]==='1'){
        return `${quarterValue[0]}-01-01`;
      }
      else if(quarterValue[1]==='2'){
        return `${quarterValue[0]}-04-01`;
      }
      else if(quarterValue[1]==='3'){
        return `${quarterValue[0]}-07-01`;
      }
      else if(quarterValue[1]==='4'){
        return `${quarterValue[0]}-10-01`;
      }
    }
  }
  const calcMailFlag = () => {
    let _startDate: any = "";
    let _endDate: any = "";
    let mailFlag: boolean = false;
    if(selectedOboType==='CustomRange'){
      _startDate = moment(startDate).startOf('month').format('YYYY-MM-DD');
      _endDate = moment(endDate).endOf('month').format('YYYY-MM-DD');;
    }
    else if(selectedOboType==='Quarter'){
      _endDate = getQuarterEndDate(selectQuarters[0]);
      _startDate= getQuarterStartDate(selectQuarters[selectQuarters.length-1]);
    }
    else if(selectedOboType==='Month'){
      _startDate = moment(revenueMonth.toISOString()).startOf('month').format('YYYY-MM-DD');
      _endDate = moment(revenueMonth.toISOString()).endOf('month').format('YYYY-MM-DD');
    }
    else if(selectedOboType==='TillMonth'){
      _startDate = moment(revenueMonth.toISOString()).startOf('year').format('YYYY-MM-DD');
      _endDate = moment(revenueMonth.toISOString()).endOf('month').format('YYYY-MM-DD');
    }
    if(moment(_endDate).diff(moment(_startDate),'month')>6){
      mailFlag = true;
    }
    return {mailFlag,startDate:_startDate,endDate:_endDate};
  }
  
  const getQuarterEndDate = (quarter:any) => {
    let quarterValue = quarter.split('-');
    if(quarterValue.length>1){
      if(quarterValue[1]==='1'){
        return `${quarterValue[0]}-03-31`;
      }
      else if(quarterValue[1]==='2'){
        return `${quarterValue[0]}-06-30`;
      }
      else if(quarterValue[1]==='3'){
        return `${quarterValue[0]}-09-30`;
      }
      else if(quarterValue[1]==='4'){
        return `${quarterValue[0]}-12-31`;
      }
    }
  }

  const getopportunityIds = (data:any) => {
		let tempOppIds:any[] = [];
		data.map((item:any) => {
			if(item.opportunityID){
				tempOppIds.push(item.opportunityID);
			}
		});
		return tempOppIds;
	}
  
  const handleFilterSearch = () => {
    
    let dateCalc =calcMailFlag()
    setNoDataFlag(false);
    
    dispatch(fetchOBOReport({
      'payload':{
        "clientName": selectedClient,
        "bu": selectedBu?selectedBu!=="ALL"?getSelectedBu(selectedBu):"":"",
        "year": moment(dateCalc.startDate).year() || "",
        "type":selectedOboType,
        "startDate":dateCalc.startDate,
        "endDate":dateCalc.endDate,
        "isMailFlag": dateCalc.mailFlag.toString(),
      }
    })).then((res: any) => {
      if (res.type === 'reports/fetchOBOReport/fulfilled') {
							if(!dateCalc.mailFlag){
								setOboReportData(res.payload.data);
        setTotalContractValue(res.payload.sumOfTCV);
        setTotalOpportunity(res.payload.totalOpportunities);
        setTotalRevenueRecognised(res.payload.sumOfRevenue);
        setTotalOBO(res.payload.obo);
        console.log("parent opportunity list",getopportunityIds(res.payload.data));
        if(res.payload.data.length>0){
          setShowDownloadReport(true);
        }else{
          setNoDataFlag(true);
        }
        if(selectedClient!=="ALL"){
          setShowTable(true);
        }
        else{
          setShowTable(false);
        }
							}
							else{
								notification.success({
									message: 'Success',
									description: 'Since the data is of more than Six months, the OBO report will be mailed to you.',
								});
							}

      }else{
        rejectedApiMessage(res.payload);
      } 
      setIsMailFlag(dateCalc.mailFlag);
    });
  }
  const quarterOfYear = (date:any) => Math.ceil((date.getMonth() + 1) / 3);
  const getQuarterMonths = (quarter:any) => {
    if(quarter===1){
      return 'JANUARY,FEBRUARY,MARCH';
    }
    else if(quarter===2){
      return 'APRIL,MAY,JUNE';
    }
    else if(quarter===3){
      return 'JULY,AUGUST,SEPTEMBER';
    }
    else if(quarter===4){
      return 'OCTOBER,NOVEMBER,DECEMBER';
    }
    
  }
  const columns : ColumnsType<DataType> = [
    {
      title: 'Client Name',
      dataIndex: 'client',
      key: 'client',
      width: 150,
      fixed: 'left',
      ...getColumnSearchProps('client'),
    },
    {
      title: 'Opportunity ID',
      dataIndex: 'opportunityID',
      key: 'opportunityID',
      width: 150,
      fixed: 'left',
      ...getColumnSearchProps('opportunityID'),
    },
    {
      title: 'Opportunity Name',
      dataIndex: 'opportunityName',
      key: 'opportunityName',
      width: 150,
      ...getColumnSearchProps('opportunityName'),
    },
    {
      title: 'Contract Value',
      dataIndex: 'sumOfTCV',
      key: 'sumOfTCV',
      width: 150,
      render: (text: any, record: any) => {
        return(
          <span>{`$${formatNumberWithCommas(text)}`}</span>
        )
      }
    },
    {
      title: 'Revenue Till Date',
      dataIndex: 'revenue',
      key: 'revenue',
      width: 150,
      render: (text: any, record: any) => {
        return(
          <span>{`$${formatNumberWithCommas(text)}`}</span>
        )
      }
    },
    {
      title: 'OBO value',
      dataIndex: 'obo',
      key: 'obo',
      width: 150,
      render: (text: any, record: any) => {
        return(
          <span>{`$${formatNumberWithCommas(text)}`}</span>
        )
      }
    },
    {
      title: 'SOWs',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      width: 50,
      render: (text: string, record: any) => {
        return(
          <Button type='link' style={{background:'none', border:'none'}} onClick={()=>viewSOWLevelOBO(record)}><EyeOutlined /></Button>
        )
      }
    },
  ];
  
  const handleOboDownload = () => {
    let dateCalc =calcMailFlag()
    setNoDataFlag(false);
    dispatch(getOboDownloadFile({payload: {
      "clientName": selectedClient,
      "bu": selectedBu?selectedBu!=="ALL"?getSelectedBu(selectedBu):"":"",
      "year": moment(dateCalc.startDate).year() || "",
      "type":selectedOboType,
      "startDate":dateCalc.startDate,
      "endDate":dateCalc.endDate,
      "isMailFlag": dateCalc.mailFlag.toString(),
      
    }})).then(
      (response: any) => {
        if (response.type !== 'reports/getOboDownloadFile/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else{
          
          const fileName = response.payload?.headers?.get("content-disposition")?.split("filename=")[1];
          const blob = response.payload.data;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      }
    );
  }
  
  const handleSelectAll = () => {
    setSelectedClient(clientList);
  }
  
  const handleSelectAll_quarters = () => {
    setSelectQuarters(quarterOptions);
  }
  
  const handleSelectAll_BU = () => {
    setSelectedBu(buList);
  }
  const isDisabledQuarter = (item:any) => {
    //only enable the options next and previous to the selected quarters index value and make rest all disable, if no quarters selected then all should be enabled
    if(selectQuarters.length===0){
      return false;
    }
    let item_selected = selectQuarters.find((quarter:any) => quarter===item.value);
    if(item_selected){
      return false;
    }
    
    let itemindex = quarterOptions.findIndex((quarter:any) => quarter.value===item.value);
    let selectedQuarterFirstIndex = quarterOptions.findIndex((quarter:any) => quarter.value===selectQuarters[0]);
    let selectedQuarterLastIndex = quarterOptions.findIndex((quarter:any) => quarter.value===selectQuarters[selectQuarters.length-1]);
    if(itemindex == selectedQuarterLastIndex+1 || itemindex == selectedQuarterFirstIndex-1){
      return false;
    }
    else{
      return true;
    }
    
  }
  
  const isSearchEnabled = () => {
    if(selectedClient.length>0){
      if(selectedOboType === "TillMonth" && revenueMonth){
        return true;
      }
      if(selectedOboType === "Month" && revenueMonth){
        return true;
      }
      if(selectedOboType === "Quarter" && selectQuarters.length>0){
        return true;
      }
      if(selectedOboType === "CustomRange" && startDate && endDate){
        return true;
      }
    }
    return false;
    
  }
  const getclientlistdata_selectedclient_List_atstartingpositions_without_duplication = (clientList:any,selectedClient:any) => {
    let tempClientList = [...clientList];
    let tempSelectedClient = [...selectedClient];
    let tempClientList1 = [];
    tempClientList1 = tempClientList.filter((item:any) => {
      return !tempSelectedClient.includes(item);
    });
    const getSortKey = (item: any) => typeof item === 'string' ? item : (item.label || item.value || '');
    tempClientList1.sort((a: any, b: any) => getSortKey(a).localeCompare(getSortKey(b)));
    return [...tempSelectedClient,...tempClientList1];
  }
  return (
    <Spin spinning={reportsData?.loading || orderDashboardData?.loading} tip="Loading..." >
    <div className='row'>
    <h2 className='col-lg-6 col-sm-12 page-heading'>
    Open Book Orders DASHBOARD
    </h2>
    </div>
    <div className='row' style={{margin:'0px 10px 20px 0px',textAlign:'center'}}>
    <span style={{font:'normal normal bold 12px / 15px Nunito Sans', color: '#034ea2'}}>{`(Data refresh occurs daily, with the latest update completed yesterday.)`}</span>
    </div>
    <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
    <div 
    className='
        
        custom-fieldcolumn' 
    style={{marginLeft:'10px', width:'35%'}}>
    <FloatLabel label="Client Name *" 
    value= {selectedClient}
    isMultiSelect={true}
    > 
    <Select
    autoClearSearchValue
    mode="multiple"
    size='middle'
    className='financialspoc-select'
    style={{ width: '100%',maxHeight:'100px', minHeight:'58px' }}
    optionFilterProp="children"
    value= {selectedClient.map((item:any) => ({ value: item, label: item }))}
    maxTagCount={'responsive'}
    
    onChange={(value:string)=>handleChangedValue('client',value)}
    filterOption={(input:any, option:any) =>
      option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    options={getclientlistdata_selectedclient_List_atstartingpositions_without_duplication(clientList,selectedClient).map((item:any) => ({ value: item, label: item }))}
    dropdownRender={menu => (
      <>
      <div style={{display:'flex', justifyContent:'space-around', margin:'5px'}}>
      <Link onClick={()=>handleSelectAll()} disabled={selectedClient.length===clientList.length} >Select All</Link>
      <Link onClick={()=>handleChangedValue('client',[])} disabled={selectedClient.length==0}>Clear All</Link>
      </div>
      {menu}
      </>
    )}
    >
    </Select>
    </FloatLabel>
    </div>
    <div 
    className=' custom-fieldcolumn'
    style={{width:'35%'}}>
    <FloatLabel label="Business Unit" value={selectedBu} >
    <Select
    autoClearSearchValue
    mode="multiple"
    size='middle'
    className='financialspoc-select'
    style={{ width: '100%',maxHeight:'100px', minHeight:'58px' }}
    optionFilterProp="children"
    value= {selectedBu.map((item:any) => ({ value: item.value, label: item.label }))}
    maxTagCount={'responsive'}
    
    onClear={()=>setSelectedBu([])}
    onChange={(value:string)=>handleChangedValue('bu',value)}
    filterOption={(input:any, option:any) =>
      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    options={getclientlistdata_selectedclient_List_atstartingpositions_without_duplication(buList,selectedBu).map((item:any) => ({ value: item.value, label: item.label }))}
    dropdownRender={menu => (
      <>
      <div style={{display:'flex', justifyContent:'space-around', margin:'5px'}}>
      <Link onClick={()=>handleSelectAll_BU()} disabled={selectedBu.length===buList.length} >Select All</Link>
      <Link onClick={()=>handleChangedValue('bu',[])} disabled={selectedBu.length==0}>Clear All</Link>
      </div>
      {menu}
      </>
    )}
    >
    </Select> 
    </FloatLabel>
    </div>
    <div
    className=' custom-fieldcolumn'
    style={{width:'20%'}}>
    {showDownloadReport && !isMailFlag &&
      <Button style={{height:'58px',textAlign:'center',marginLeft:'10px',borderRadius:'0', backgroundColor:'#034ea2', font:'normal normal 600 12px / 16px Nunito Sans'}}
      className='ant-btn-primary'
      onClick={()=>handleOboDownload()}
      >
      
      <DownloadOutlined  style={{fontSize:'20px'}}/>
      <span style={{font:'normal normal 600 12px / 16px Nunito Sans'}}>OBO Report</span>
      </Button>
    }
    </div>
    </div>
    <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
    <div
    className=' custom-fieldcolumn'
    style={{ width:'20%',marginLeft:'10px'}}>
    <FloatLabel label="Time Period" value={selectedOboType}>
    <Select
    showSearch
    size='middle'
    style={{ width: '100%',height:58 }}
    ref={selectRef_type}
    optionFilterProp="children"
    value={selectedOboType}
    
    onClear={()=>setSelectedBu(null)}
    onSelect={(value:string)=>handleChangedValue('oboType',value)}
    filterOption={(input:any, option:any) =>
      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    options={oboTypeOptions.map((item:any) => ({ value: item.value,label:item.label }))}
    ></Select>
    </FloatLabel>
    </div>
    {selectedOboType === "TillMonth" && <div 
      
      style={{ width:'20%'}}>
      <FloatLabel label="Revenue till month *" value={revenueMonth}>
      <DatePicker.MonthPicker
      size='middle'
      style={{ width: '100%', height: 58,paddingTop:'15px' }}
      onChange={(value:any)=>{handleChangedValue('revenueMonth',value); selectRef_tillmonth.current?.blur();}} 
      ref={selectRef_tillmonth}
      allowClear={false}
      placeholder=""
      disabledDate={(current) => {
        return current && current > moment();
      }}
      value={revenueMonth?dayjs(revenueMonth):null}/>
      </FloatLabel>
      </div>}
      {
        selectedOboType === "Month" && 
        <div 
        
        style={{ width:'20%'}}>
        <FloatLabel label="Revenue Month *" value={revenueMonth}>
        <DatePicker.MonthPicker
        size='middle'
        style={{ width: '100%', height: 58,paddingTop:'15px' }}
        onChange={(value:any)=>{handleChangedValue('revenueMonth',value); selectRef_month.current?.blur();}} 
        ref={selectRef_month}
        allowClear={false}
        placeholder=""
        disabledDate={(current) => {
          return current && current > moment();
        }}
        value={revenueMonth?dayjs(revenueMonth):null}/>
        </FloatLabel>
        </div>
        
      }
      {
        selectedOboType === "Quarter" && 
        <div 
        className=' custom-fieldcolumn'
        style={{ width:'30%'}}
        >
        <FloatLabel label="Revenue Quarter *" value={selectQuarters}
        isMultiSelect={true}>
        <Select
        showSearch
        mode="multiple"
    				size='middle'
    				className='financialspoc-select'
        style={{ width: '100%',height:'58px' }}
        ref={selectRef_type}
        optionFilterProp="children"
        value={selectQuarters}
        allowClear={false}
        maxTagCount={'responsive'}
        onChange={(value:string)=>handleChangedValue('selected_quarters',value)}
        filterOption={(input:any, option:any) =>
          option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        dropdownRender={menu => (
          <>
          <div style={{display:'flex', justifyContent:'space-around', margin:'5px'}}>
          <Link onClick={()=>handleSelectAll_quarters()} disabled={selectQuarters.length===quarterOptions.length} >Select All</Link>
          <Link onClick={()=>setSelectQuarters([])} disabled={selectQuarters.length==0}>Clear All</Link>
          </div>
          {menu}
          </>
        )}
        >
        {quarterOptions.map((item:any) => (
          <option disabled={isDisabledQuarter(item)} key={item.value} value={item.value}>{item.label}</option>
        ))}
        </Select>
        </FloatLabel>
        </div>
      }
      
      {
        selectedOboType === "CustomRange" &&
        <>
        <div 
        className=' custom-fieldcolumn'
        style={{ width:'20%'}}>
        <FloatLabel label="Start Month *" value={startDate}>
        <DatePicker.MonthPicker
        size='middle'
        style={{ width: '100%', height: 58,paddingTop:'15px' }}
        onChange={(value:any)=>{handleChangedValue('custom_startDate',value);}} 
        allowClear={false}
        placeholder=""
        disabledDate={(current) => {
          return current && current > moment();
        }}
        value={startDate?dayjs(startDate):null}/>
        </FloatLabel>
        </div>
        <div
        className=' custom-fieldcolumn'
        style={{ width:'20%'}}>
        <FloatLabel label="End Month *" value={endDate}>
        <DatePicker.MonthPicker
        size='middle'
        style={{ width: '100%', height: 58,paddingTop:'15px' }}
        onChange={(value:any)=>{handleChangedValue('custom_endDate',value);}} 
        allowClear={false}
        placeholder=""
        disabledDate={(current: any) => current && (current < moment(startDate)|| current > moment())}
        value={endDate?dayjs(endDate):null}/>
        </FloatLabel>
        </div>
        </>
      }
      <div 
      style={{ width:'20%'}}
      
      >{isSearchEnabled() ? <Button style={{height:'58px',textAlign:'center',borderRadius:'0', backgroundColor:'#034ea2', font:'normal normal 600 12px / 16px Nunito Sans'}}
      className='ant-btn-primary'
      onClick={()=>handleFilterSearch()}
      disabled={!isSearchEnabled()}
      >
      <SearchOutlined  style={{fontSize:'20px'}}/></Button>
      :
      <Button style={{height:'58px',textAlign:'center',borderRadius:'0',}}
      className='ant-btn-primary'
      onClick={()=>handleFilterSearch()}
      disabled={!isSearchEnabled()}
      >
      <SearchOutlined  style={{fontSize:'20px'}}/></Button>
    }
    
    
    
    {/* {showDownloadReport &&
      <Button style={{height:'58px',textAlign:'center',marginLeft:'10px',borderRadius:'0', backgroundColor:'#034ea2', font:'normal normal 600 12px / 16px Nunito Sans'}}
      className='ant-btn-primary'
      onClick={()=>handleOboDownload()}
      >
      
      <DownloadOutlined  style={{fontSize:'20px'}}/>
      <span style={{font:'normal normal 600 12px / 16px Nunito Sans'}}>OBO Report</span>
      </Button>
      } */}
      
      </div>
      </div>
      {
        isMailFlag && false && 
        <div style={{textAlign:'center',height:'400px', display:'flex',justifyContent:'center',alignItems:'center' }}>
        <MailOutlined />
        <span style={{font:'normal normal bold 12px / 15px Nunito Sans', color: '#034ea2'}}>{`(Since the data is of more than Six months, the OBO report will be mailed to you.)`}</span>
        </div>
      }
      
      {
        isMailFlag && 
        <div style={{textAlign:'center',height:'400px', display:'flex',justifyContent:'center',alignItems:'center' }}>
        
        <Empty description={<span style={{font:'normal normal bold 14px / 15px Nunito Sans', color: '#034ea2'}}>{`Since the data is of more than Six months, the OBO report will be mailed to you.`}</span>} />
        </div>
      }
      {
        oboReportData.length>0 && !noDataFlag && !isMailFlag &&
        <Row 
        style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}
        >
        <Col span={5} style={{margin:'20px'}}>
        <DashboardCard title="Total Opportunities" value={totalopportunity} labelType="text" />
        </Col>  
        <Col span={5} style={{margin:'20px'}}>
        <DashboardCard title="Total Contract Value" value={totalContractValue} labelType="currency" />
        
        </Col>
        <Col span={5} style={{margin:'20px'}}>
        <DashboardCard title="Total Revenue Recognised" value={totalRevenueRecognised} labelType="currency" />
        </Col>
        <Col span={5} style={{margin:'20px'}}>
        <DashboardCard title="OBO Value" value={totalOBO} labelType="currency" />
        
        </Col>
        
        </Row>
      }
      { oboReportData.length>0 && showTable && !isMailFlag&&<Table 
        className='table-style'
        columns={columns} 
        dataSource={oboReportData?oboReportData:[]  } 
        scroll={{ x: 'max-content', y: 350}}
        pagination={{
          pageSize: 10,
          showSizeChanger: false,
        }}
        />
      }
      
      
      <OboDetailsModal onCancel={()=>dispatch(setoboModalDetails({isModalOpen:false,
        activeTab:'sowTab',
        selectedSow:{},
        selectedOpp:{}}))}
        visible={reportsData.oboModal.isModalOpen}/>
        </Spin>
      )
    }
    
    export default OboReportContainer;